import React from "react";

function Logo() {
  return (
    <svg
      className="w-full h-full"
      version="1.1"
      viewBox="0 0 1980 1528"
      width="1980"
      height="1528"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        transform="translate(176,328)"
        d="m0 0h252l2 4 1 957 334 1 2 1-1 5-173 173-2 1h-455l-1-1v-7l11-57 20-104 26-136 12-63 30-156 8-43 9-46 12-63 14-73 16-84 15-77 1-6v-10l-9-15-9-14-15-24-11-17-15-24-15-23-11-18-14-22-24-38-10-16z"
        fill="#FFFFFF"
      />
      <path
        transform="translate(1533,328)"
        d="m0 0h251l1 5-14 22-12 19-14 22-24 38-28 44-12 19-11 18-11 17-8 13 1 11 8 41 8 43 9 46 8 43 8 40 8 43 13 67 8 43 15 77 10 53 19 100 11 57 16 83 11 58 14 73 8 41-1 5-1 1h-454l-8-7-33-33-6-5-7-8-122-122-1-4 2-1 335-1 1-958z"
        fill="#FFFFFF"
      />
      <path
        transform="translate(653,634)"
        d="m0 0 5 1 12 14 10 11v2h2l9 11 11 12 7 8 9 10 12 14 10 11 9 11 14 15 9 11 12 13 7 8v2h2l9 11 12 13 9 11 15 16 9 11 12 13 7 8 11 13 12 13 9 11 14 15 9 11 12 13 9 11 12 13 7 8 9 10 7 8 1 1h5l10-11 7-8 9-10 12-14 11-12 7-8 12-14 10-11 9-11 13-14 7-8 12-14 13-14 9-11 12-13 9-11 14-15 9-11 12-13 9-11 7-7 9-11 12-13 9-11 7-7 7-8 12-14 10-11 1-2h2l2-4 11-12 9-11 11-12 6-7 4 1v284l-8 10-9 10-7 8-12 14-13 14-9 11-12 13-7 8-13 15-10 11-9 11-7 7-9 11-11 12-7 8-9 10-12 14-11 12-9 11-14 15-9 11-11 12-7 8-12 14-12 13-9 11-14 15-9 11-12 13-8 10h-2l-2 4-11 12-7 8-3 3-5-1-11-12-9-11-11-12-7-8-9-10-9-11-12-13-7-8-10-11-9-11-13-14-7-8-12-14-11-12-9-11-13-14-9-11-14-15-9-11-12-13-7-8-12-14-2-4h-2l-9-11-12-13-7-8-9-10-6-7v-2h-2l-9-11-12-13-9-11-7-7-7-8-9-11-1-2v-283z"
        fill="#FFFFFF"
      />
      <path
        transform="translate(288,64)"
        d="m0 0h535l4 4 7 24 14 51 16 58 11 40 18 65 8 30 13 47 17 62 15 54 10 37 12 43 10 37-1 5-4-2-10-11-9-11-7-7-7-8-12-14-10-11v-2h-2l-4-5v-2h-2l-7-8-12-14-9-10-7-8-10-11-9-11-14-15-9-11-12-13-9-11-14-15-9-11-12-13-7-8-12-14-2-4h-2l-7-8-12-14-11-12-12-14-10-11-9-11-7-7-5-6v-2h-2l-9-11-12-13-4-5-2-1-552-1-2-4 2-3h2v-2l6-5 7-8 3-1 2-4 3-3h2l1-3h2l2-4h2l1-3h2l2-4h2l1-3h2l2-4h2l1-3h2l2-4h2l1-3h2v-2h2v-2h2v-2l3-3h2v-2h2v-2l3-3h2l2-4h2l1-3h2l2-4h2l1-3h2l2-4h2l1-3h2v-2h2v-2h2l1-3h2v-2l6-5 5-5 3-4h2l2-4 3-3h2l1-3 4-4h2l1-3 4-4h2l2-4 3-3h2l2-4 3-3h2l2-4 3-3h2v-2h2l2-4 3-1v-2h2l2-4 3-3h2l2-4 3-3h2v-2z"
        fill="#FFFFFF"
      />
      <path
        transform="translate(1138,64)"
        d="m0 0h535l6 3 183 183v4l-2 1-551 1-6 5-8 10h-2l-2 4-11 12-8 10h-2l-2 4-11 12-9 11-12 13-9 11-6 7h-2l-2 4-12 13-9 11-7 7-9 11-11 12-7 8-9 11h-2l-2 4-11 12-9 11-14 15-7 8-12 14-9 10-7 8-12 14-12 13-9 11-14 15-9 11-12 13-9 11-14 15-4 4h-4v-2h2l1-9 10-35 8-30 14-51 11-39 8-30 18-65 13-48 10-36 9-32 8-30 18-65 17-62 6-20z"
        fill="#FFFFFF"
      />
    </svg>
  );
}

export default Logo;
